import { render } from "./app-form-view.vue?vue&type=template&id=6999ec16&scoped=true"
import script from "./app-form-view.vue?vue&type=script&lang=js"
export * from "./app-form-view.vue?vue&type=script&lang=js"

import "./app-form-view.vue?vue&type=style&index=0&id=6999ec16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6999ec16"]])

export default __exports__